import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import axios from "axios"
import AppLayout from "@/components/app/AppLayout"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { API_BASE } from "@/config/api"
import { formatRon } from "@/lib/format"
import { HrSubnav } from "./HrSubnav"
import { toast } from "sonner"

const API = API_BASE

export default function HrPayroll() {
  const { t } = useTranslation()
  const [month, setMonth] = useState(() => new Date().toISOString().slice(0, 7))
  const [payroll, setPayroll] = useState(null)

  const load = () => {
    axios.get(`${API}/hr/payroll/${month}`).then((r) => setPayroll(r.data)).catch(() => {})
  }

  useEffect(() => { load() }, [month])

  const downloadCsv = async (format) => {
    const { data } = await axios.get(`${API}/hr/payroll/${month}/export`, { params: { format } })
    const blob = new Blob([data.csv], { type: "text/csv;charset=utf-8" })
    const a = document.createElement("a")
    a.href = URL.createObjectURL(blob)
    a.download = `state-plata-${month}-${format}.csv`
    a.click()
  }

  const closeMonth = async () => {
    await axios.post(`${API}/hr/payroll/${month}/close`)
    toast.success(t("app.hr.payroll.toastClosed"))
    load()
  }

  const lines = payroll?.lines || []

  return (
    <AppLayout title={t("app.hr.payroll.title")}>
      <HrSubnav />
      <p className="text-sm text-muted-foreground mb-4">Calcul CAS 25%, CASS 10%, impozit 10% (parametri 2026). Nu înlocuiește contabilul.</p>
      <div className="flex flex-wrap gap-3 mb-6 items-end">
        <div><Label>Lună</Label><Input type="month" value={month} onChange={(e) => setMonth(e.target.value)} /></div>
        <Button variant="outline" size="sm" onClick={() => downloadCsv("112")}>Export 112 CSV</Button>
        <Button variant="outline" size="sm" onClick={() => downloadCsv("saga")}>Export Saga</Button>
        <Button variant="outline" size="sm" onClick={() => downloadCsv("smartbill")}>Export SmartBill</Button>
        <Button size="sm" onClick={closeMonth}>Închide luna</Button>
      </div>
      {payroll?.totals && (
        <p className="text-sm mb-4">Total brut: {formatRon(payroll.totals.gross)} · Net: {formatRon(payroll.totals.net)}</p>
      )}
      <table className="w-full text-sm rounded-xl border border-border overflow-hidden">
        <thead className="bg-muted/50">
          <tr>
            <th className="p-3 text-left">Angajat</th>
            <th className="p-3 text-right">Brut</th>
            <th className="p-3 text-right">CAS</th>
            <th className="p-3 text-right">CASS</th>
            <th className="p-3 text-right">Impozit</th>
            <th className="p-3 text-right">Net</th>
          </tr>
        </thead>
        <tbody>
          {lines.map((ln) => (
            <tr key={ln.employee_id} className="border-t border-border">
              <td className="p-3">{ln.employee_name}</td>
              <td className="p-3 text-right">{formatRon(ln.gross)}</td>
              <td className="p-3 text-right">{formatRon(ln.cas)}</td>
              <td className="p-3 text-right">{formatRon(ln.cass)}</td>
              <td className="p-3 text-right">{formatRon(ln.income_tax)}</td>
              <td className="p-3 text-right font-medium">{formatRon(ln.net)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </AppLayout>
  )
}
